<template>
    <van-overlay :show="show" @click="show = false" style="z-index: 1">
        <div class="wrapper" @click.stop>
            <div class="block">
                <div class="header">
                    <a class="close" @click="close">
                        <van-icon name="cross" />
                    </a>
                    
                    <div class="title">
                        <span>Confirmation</span>
                    </div>
                </div>
                
                <div class="content">
                    <div v-if="order.isDelivery && serviceType.delivery_service == 'teleport'" class="info">
                        <p>Estimated Time Arrival</p>
                        <span v-if="serviceType.choosedService.includes('INSTANT')" style="color: #ee2d24; font-weight: bolder">Within 1 Hours</span>
                        <span v-if="serviceType.choosedService.includes('FLASH')" style="color: #ee2d24; font-weight: bolder">Within 4 Hours</span>
                        <span v-if="serviceType.choosedService.includes('STANDARD')" style="color: #ee2d24; font-weight: bolder">More than 1 Day</span>
                    </div>
                    <div v-else-if="(order.isDelivery && serviceType.delivery_service == 'owntransport') || (order.isDelivery && serviceType.delivery_service == 'delyva') || (order.isDelivery && serviceType.delivery_service == 'lalamove')" class="info">
                        <p>Order Details</p>
                    </div>
                    <div v-else class="info">
                        <p v-if="order.isDelivery">Estimated Time Arrival</p>
                        <p v-else>Estimated Time Ready</p>
                        <p style="color: #ee2d24; font-weight: bolder; margin: 0; font-size: 16px;">{{dateETA}}</p>
                        <span style="color: #ee2d24; font-weight: bolder">{{fromETA}} - {{toETA}}</span>
                    </div>

                    <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'teleport'" style="font-size: 14px">
                        <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                            <div>
                                <icon v-if="serviceType.choosedService == 'STANDARD_24'" color="#ee2d24" size="20px" name="plane"/>
                                <icon v-else-if="serviceType.choosedService.includes('BIKE')" color="#ee2d24" size="20px" name="motorcycle"/>
                                <icon v-else-if="serviceType.choosedService.includes('CAR')" color="#ee2d24" size="20px" name="car"/>
                            </div>
                            <div v-if="serviceType.choosedService == 'STANDARD_24'" style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_24',' COURIER')}}</div>
                            <div v-else-if="serviceType.choosedService.includes('BIKE')" style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_',' ')}}</div>
                            <div v-else style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_',' ')}}</div>
                        </div>
                    </div>

                    <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'lalamove'" style="font-size: 14px">
                        <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                            <div>
                                <icon v-if="serviceType.choosedService.includes('VAN')" color="#ee2d24" size="20px" name="plane"/>
                                <icon v-else-if="serviceType.choosedService.includes('BIKE')" color="#ee2d24" size="20px" name="motorcycle"/>
                                <icon v-else-if="serviceType.choosedService.includes('CAR')" color="#ee2d24" size="20px" name="car"/>
                                <icon v-else-if="serviceType.choosedService.includes('TRUCK')" color="#ee2d24" size="20px" name="truck"/>
                            </div>
                            <div v-if="serviceType.choosedService == 'STANDARD_24'" style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_24',' COURIER')}}</div>
                            <div v-else-if="serviceType.choosedService.includes('BIKE')" style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_',' ')}}</div>
                            <div v-else style="padding-left: 16px; text-align: left;">{{serviceType.choosedService.replace('_',' ')}}</div>
                        </div>
                    </div>

                    <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'owntransport'" style="font-size: 14px">
                        <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                            <div>
                                <icon color="#ee2d24" size="20px" name="car"/>
                            </div>
                            <div style="padding-left: 16px; text-align: left;">OWN TRANSPORT</div>
                        </div>
                    </div>

                    <div class="delivery" v-if="order.isDelivery && serviceType.delivery_service == 'delyva'" style="font-size: 14px">
                        <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                            <div>
                                <van-icon color="#ee2d24" size="20px" name="logistics" />
                            </div>
                            <div style="padding-left: 16px; text-align: left;">{{serviceType.descService}}</div>
                        </div>
                    </div>

                    <div class="schedule" v-if="order.schedule.datetime" :style="(order.isDelivery && serviceType.delivery_service == 'teleport') || (order.isDelivery && serviceType.delivery_service == 'lalamove') || (order.isDelivery && serviceType.delivery_service == 'owntransport') || (order.isDelivery && serviceType.delivery_service == 'delyva')? 'display:none;':''" style="font-size: 14px">
                        <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                            <div>
                                <van-icon color="#ee2d24" size="20px" name="clock-o" />
                            </div>
                            <div v-if="order.schedule.type" style="padding-left: 16px; text-align: left;">SCHEDULE ({{order.schedule.datetime | dateFormat('dddd, D MMM YYYY, HH:mm')}})</div>
                            <div v-else style="padding-left: 16px; text-align: left;">INSTANT</div>
                        </div>
                    </div>

                    <div class="address" style="font-size: 14px" v-if="order.address">
                        <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                            <div>
                                <van-icon color="#ee2d24" size="20px" name="location-o" />
                            </div>
                            <div style="padding-left: 16px; text-align: left;">{{order.address.address2 + ',' + order.address.address1}}</div>
                        </div>
                    </div>

                    <div class="personal" style="font-size: 14px" v-if="order.user">
                        <div class="source" style="display: flex; align-items: center; padding: 0 16px; margin: 3px 0;" v-if="order.user.name">
                            <div>
                                <van-icon color="#ee2d24" size="20px" name="user-o" />
                            </div>
                            <div style="padding-left: 16px; text-align: left;">{{order.user.name}}</div>
                        </div>
                        <div class="source" style="display: flex; align-items: center; padding: 0 16px; margin: 3px 0;" v-if="order.user.contact">
                            <div>
                                <van-icon color="#ee2d24" size="20px" name="phone-o" />
                            </div>
                            <div style="padding-left: 16px; text-align: left;">{{order.user.contact}}</div>
                        </div>
                        <div class="source" style="display: flex; align-items: center; padding: 0 16px; margin: 3px 0;" v-if="order.user.email">
                            <div>
                                <van-icon color="#ee2d24" size="20px" name="envelop-o" />
                            </div>
                            <div style="padding-left: 16px; text-align: left;">{{order.user.email}}</div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="slider">
                        <drag-verify 
                            :width="width"
                            :height="height" 
                            :text="text" 
                            :success-text="successText" 
                            :background="background" 
                            :progress-bar-bg="progressBarBg" 
                            :completed-bg="completedBg" 
                            :handler-bg="handlerBg" 
                            :handler-icon="handlerIcon" 
                            :text-size="textSize" 
                            :success-icon="successIcon" 
                            :circle="getShape"
                            @passcallback="submit"></drag-verify>
                    </div>
                </div>
            </div>
        </div>
    </van-overlay>
</template>
<script>
import dragVerify from 'vue-drag-verify';
import moment from 'moment';
export default {
    components: {
        dragVerify
    },
    props: {
        confirm: {
            type: Function
        },
        cancel: {
            type: Function
        },
        store: {
            type: Object
        },
        order: {
            type: Object
        },
        serviceType: {
            type: Object
        }
    },
    data() {
        return {
            show: true,
            width: '250',
            text: 'Swipe to confirm',
            successText: 'AWESOME!',
            color: '#fff',
            progressBarBg: '#ee2d24',
            completedBg: '#ee2d24',
            textSize: '14px',
            dateETA: '',
            fromETA: '',
            toETA: '',
        }
    },
    created() {
        this.calculateETA();
    },
    methods: {
        calculateETA() {
            let eta = moment(this.order.schedule.datetime).toDate();
            let from, to;

            if(this.order.isDelivery) {
                from = moment(eta).add(this.order.etaInMinute/60, 'm');
                to = moment(eta).add(this.order.etaInMinute/60, 'm').add(15, 'm');
            } else {
                from = moment(eta);
                to = moment(eta).add(this.store.readyInMinute, 'm');
            }

            this.fromETA = from.format('HH:mm');
            this.toETA = to.format('HH:mm');
            this.dateETA = to.format('dddd, D MMM YYYY');
        },
        close() {
            this.show = false;
            this.cancel();
        },
        submit() {
            this.confirm();
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.block {
    background-color: #f2f2f2;
    border-radius: 6px;
    width: 80%;
}

.flex {
    align-items: center;
    padding: 6px;
}

.icon-text {
    padding-left: 6px;
}

.dot {
    line-height: 6px;
    align-items: center;
    display: flex;
    justify-content: center;
    color: #ee2d24;
}

.title {
    text-align: center;
    background-color: #ee2d24;
    padding: 16px 16px 10px 55px;
    color: #fff;
    font-weight: 700;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.content {
    padding: 6px;
}

.btn-action {
    display: flex;
    flex: 1;
    cursor: pointer;
}

.btn-confirm {
    height: 48px;
    background-color: #ee2d24;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-right-radius: 6px;
}

.btn-cancel {
    height: 48px;
    background-color: #fff;
    color: #ee2d24;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 6px;
}

.personal, .address, .schedule, .delivery {
    margin: 6px; 
    padding: 6px 0; 
    background-color: #fff;
    border-radius: 6px;
}

.info {
    text-align: center;
    padding: 16px;
    font-size: 20px;
}

.close {
    float: right;
    padding: 16px;
    color: #fff;
}

.slider {
    margin: 6px 0;
    padding: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>